module.exports = __webpack_public_path__ + "img/icon-simple.0ed0b004.svg";